/*
 * @Author: jiahuacui
 * @Date: 2018-08-09 14:31:10
 * @LastEditors: jiahuacui
 * @LastEditTime: 2018-08-08 14:31:10
 * @Description: 
 */
  <!-- 
  详情页 - BOM结构
  props:
    id: 详情id
 -->
  <template>
    <div class="v-tabs structure">
      <div class="content">
        <div class="structure-box">
          <div class="finish-header">
            <img :src="productStructure.thumbnail"/>
            <div class="right">
              <h1>{{productStructure.name}}</h1>
              <p>规格：{{productStructure.specification}}</p>
            </div>
          </div>
          <structure :structureList="structureList"></structure>
<!--           <ul class="level-one">
            <li v-for="item in data">
              <div class="level-out">
                <div class="level-left">
                  <h1>{{item.name}}</h1>
                  <p>规格：333</p>
                </div>
                <div class="level-right">
                  <span>45/件</span>
                </div>
              </div>
              <ul class="level-one" v-if="item.children.length">
                <li v-for="it in item.children">
                  <div class="level-out">
                    <div class="level-left">
                      <h1>{{it.name}}</h1>
                      <p>规格：333</p>
                    </div>
                    <div class="level-right">
                      <span>45/件</span>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
 -->        </div>
      </div>
    </div>
 </template>
<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      productStructure: {},
      structureList: []
    }
  },
  methods: {
    getList () {
      let url = '/bomBill/getBomBillProductStructure.html'
      let params = {
        bomBillId: this.id
      }
      api.post(url, params, (data) => {
        if (data.productStructure) {
          // 获取成品等信息
          this.productStructure = data.productStructure
          if (data.productStructure.structureList.length) {
            this.structureList = data.productStructure.structureList
          }
        }
      })
    }
  },
  components: {
    structure: {
      name: 'gs',
      template: `
      <ul class="level-one">
        <li v-for="it in structureList">
          <div class="level-out">
            <div class="level-left">
              <h1>{{it.name}}</h1>
              <p>规格：{{it.specification}}</p>
            </div>
            <div class="level-right">
              <span>{{it.num}}/{{it.unit}}</span>
            </div>
          </div>
          <gs :structureList="it.children" v-if="it.children && it.children.length"></gs>
        </li>
      </ul>`,
      props: ['structureList'],
      data () {
        return {
          show: false
        }
      }
    }
  }
}
</script>
<style lang="less">
  .structure {
    .finish-header {
      display: flex;
      border: 1px solid #e5ecf7;
      background: #fff;
      position: relative;
      z-index: 50;
      img {
        width: 80px;
        height: 80px;
        padding: 15px;
      }
      .right {
        padding: 15px;
        padding-left: 0;
        h1 {
          font-size: 16px;
          margin-bottom: 15px;
        }
      }
    }
    .level-one {
      position: relative;
      li {
        .level-out {
          position: relative;
          z-index: 50;
          border: 1px solid #e5ecf7;
          background: #fff;
          margin-left: 35px;
          margin-top: 10px;
          padding: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:before {
          position: absolute;
          content: "";
          height: 100%;
          width: 0;
          border-left: 1px solid #dce1e8;
          left: 20px;
          top: 0;
          margin-top: -10px;
          z-index: 1
        }
        &:last-of-type:before {
          top: -20px;
        }
      }
      .level-left {
        &:before {
          position: absolute;
          width: 5px;
          height: 5px;
          border-radius: 5px;
          background-color: #6F8DBB;
          left: -18px;
          top: 35%;
          content: "";
          z-index: 2
        }
        &:after {
          content: '';
          position: absolute;
          left: -21px;
          top: 30%;
          width: 10px;
          height: 10px;
          border-radius: 100%;
          border: 1px solid #6F8DBB;
          background: #fff;
          z-index: 1
        }
        h1 {
          font-size: 16px;
          margin-bottom: 10px;
        }
        margin-right: 10px;
        border-right: 1px solid #dce1e8;
        flex: 1;
      }
      .level-one {
        margin-left: 50px;
        li:last-of-type:before {
          top: -20px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// structure.vue?096083b1